import EventEmitter from 'events'
const COMMANDS_URL = process.env.COMMANDS_URL

class CommandsClient extends EventEmitter {
  constructor (token, view) {
    super()
    this._isConnected = false
    this._url = COMMANDS_URL
    this._socket = {}
  }
  get isConnected () {
    return this._isConnected
  }
  connect () {
    const token = localStorage.getItem('heimdall-session-token')
    this._socket = new WebSocket(`${this._url}?token=${token}`)
    this._socket.onerror = err => {
      console.error(err)
    }
    this._socket.onclose = closeEvent => {
      this.emit('close', closeEvent)
    }
    this._socket.onopen = event => {
      this._isConnected = true
      this.emit('connection', event)
    }
    this._socket.onmessage = message => {
      const data = JSON.parse(message.data)
      this.emit('transfer-update', data)
    }
  }
  sendCommand ({ commandId, vehicleId }) {
    this._socket.send(JSON.stringify({ commandId, vehicleId }))
  }
}

export default CommandsClient



// WEBPACK FOOTER //
// ./src/api/commands.js